export const queryKeys = {
  STAT_CALL_HISTORY_CUSTOM_FIELD: 'STAT_CALL_HISTORY_CUSTOM_FIELD',
  STAT_CALL_HISTORY_TAGS: 'STAT_CALL_HISTORY_TAGS',
  STAT_CALL_HISTORY_LEAD_TABLE: 'STAT_CALL_HISTORY_LEAD_TABLE'
};
